import {h, Component} from 'preact';
import {connect} from 'react-redux';

import reduce from '../reducers';
import * as actions from '../actions';
import history from '../canvas/history';
import constants from '../constants';

export default @connect(reduce, actions)
class History extends Component {
    constructor() {
        super();

        this.undo = (event) => {
            event.stopPropagation();
            history.undo();
        };

        this.redo = (event) => {
            event.stopPropagation();
            history.redo();
        };
    }

    render (props, state) {
        if (props.isVersionPreview) return null;
        return (
            <div class="history">
                <div class={'btn' + (props.hasHistoryPrev ? '' : ' disabled')} onClick={(event) => this.undo(event) } style="margin-bottom: 10px;">
                    <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-undo" } /></svg>
                </div>
                <div class={'btn' + (props.hasHistoryNext ? '' : ' disabled')} onClick={(event) => this.redo(event)}>
                    <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-redo" } /></svg>
                </div>
            </div>
        )
    }
}
